'use client'

import Box from '@mui/material/Box'
import LearnMoreIcon2 from '@public/icons/icon-granular.png'
import LearnMoreIcon3 from '@public/icons/icon-grow-users.png'
import LearnMoreIcon4 from '@public/icons/icon-open-honest.png'
import LearnMoreIcon1 from '@public/icons/icon-scalable.png'

import EcoTransItVsLuneHero from '@/components/Hero/EcoTransItVsLuneHero'
import GenericHero from '@/components/Hero/GenericHero'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import RequestDemo from '@/components/RequestDemo'
import EcoTransITVsLuneFaq from '@/sections/EcoTransITVsLuneFaq'
import EcoTransITVsLuneTable from '@/sections/EcoTransITVsLuneTable'
import GrowCustomerValue from '@/sections/GrowCustomerValue'
import LogisticsLogos from '@/sections/LogisticsLogos'
import { RenderOn } from '@/utills/DeviceUtils'

const title = `A new era of emission intelligence for logistics`
const description = `Returning unreliable emission calculations? Customers constantly asking for reports? Nobody replying to your support requests? Then it’s time to upgrade.`

export default function Page() {
    return (
        <>
            <Box>
                <RenderOn breakPoints={['xs', 'sm']}>
                    <GenericHero
                        backgroundImageMobile={'/images/heros/ecotransit-mobile.png'}
                        title={title}
                        description={description}
                        smallLabel={'EcoTransIT vs. Lune'}
                    />
                </RenderOn>
                <RenderOn breakPoints={['md', 'lg', 'xl']}>
                    <EcoTransItVsLuneHero title={title} description={description} />
                </RenderOn>
                <LogisticsLogos />
            </Box>
            <LearnMoreTiles
                tiles={[
                    {
                        title: (
                            <>
                                Flexible, scalable, <br /> and easy-to-use
                            </>
                        ),
                        description:
                            'Reliably return accurate emission tracking to fulfil your growing customer base',
                        icon: LearnMoreIcon1,
                    },
                    {
                        title: (
                            <>
                                Next-level accuracy <br /> and granularity
                            </>
                        ),
                        description:
                            'Support customer compliance with industry-leading logistics emissions intelligence',
                        icon: LearnMoreIcon2,
                    },
                    {
                        title: 'Calculate, report, reduce, and offset ',
                        description:
                            'Win more deals by accelerating your customers sustainability journey from start to finish',
                        icon: LearnMoreIcon3,
                    },
                    {
                        title: 'Rapid customer support',
                        description:
                            'Integrate, launch, and influence Lune’s product roadmap — together',
                        icon: LearnMoreIcon4,
                    },
                ]}
            />
            <EcoTransITVsLuneTable />
            <EcoTransITVsLuneFaq />
            <GrowCustomerValue />
            <RequestDemo />
        </>
    )
}
